import { getCadastroAdicional } from '@/modules/cadastros-adicionais/cadastros-adicionais-utils';

const checkCamposProdutoErpNeo = camposIntegracao => camposIntegracao.contaContabil;

const checkCamposProdutoErpTotvs = camposIntegracao => camposIntegracao.contaContabil
  && camposIntegracao.armazem;

const checkCamposProdutoErpSenior = camposIntegracao => camposIntegracao.armazem;

const checkCamposProdutoErpSeniorTeixeira = camposIntegracao => camposIntegracao.contaContabil
  && camposIntegracao.armazem && camposIntegracao.contaFinanceira;

export const checkCadastrosAdicionaisProdutoErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === 'TOTVS') {
    return checkCamposProdutoErpTotvs(camposIntegracao);
  }
  if (tipoErp === 'NEO') {
    return checkCamposProdutoErpNeo(camposIntegracao);
  }
  if (tipoErp === 'SENIOR') {
    return checkCamposProdutoErpSenior(camposIntegracao);
  }
  if (tipoErp === 'SENIOR_TEIXEIRA') {
    return checkCamposProdutoErpSeniorTeixeira(camposIntegracao);
  }
  return false;
};

const validateCamposErpSeniorTeixeira = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Depósito é obrigatório'];
  }
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta contábil é obrigatória'];
  }
  if (!camposIntegracao.contaFinanceira) {
    return [false, 'Conta financeira é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpTotvs = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Armazém é obrigatório'];
  }
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta contábil é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSenior = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Depósito é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpNeo = (camposIntegracao) => {
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta financeira é obrigatória'];
  }
  return [true, null];
};

export const validateCamposErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === 'TOTVS') {
    return validateCamposErpTotvs(camposIntegracao);
  }
  if (tipoErp === 'NEO') {
    return validateCamposErpNeo(camposIntegracao);
  }
  if (tipoErp === 'SENIOR') {
    return validateCamposErpSenior(camposIntegracao);
  }
  if (tipoErp === 'SENIOR_TEIXEIRA') {
    return validateCamposErpSeniorTeixeira(camposIntegracao);
  }
  return [true, null];
};

export const computeFrom = (tipoErp, cadastrosAdicionais) => {
  if (tipoErp === 'TOTVS') {
    return {
      armazem: getCadastroAdicional(cadastrosAdicionais, 'ARMAZEM') || null,
      contaContabil: getCadastroAdicional(cadastrosAdicionais, 'CONTA_CONTABIL') || null,
    };
  }
  if (tipoErp === 'NEO') {
    return {
      contaContabil: getCadastroAdicional(cadastrosAdicionais, 'CONTA_CONTABIL') || null,
    };
  }
  if (tipoErp === 'SENIOR') {
    return {
      armazem: getCadastroAdicional(cadastrosAdicionais, 'ARMAZEM') || null,
    };
  }
  if (tipoErp === 'SENIOR_TEIXEIRA') {
    return {
      armazem: getCadastroAdicional(cadastrosAdicionais, 'ARMAZEM') || null,
      contaContabil: getCadastroAdicional(cadastrosAdicionais, 'CONTA_CONTABIL') || null,
      contaFinanceira: getCadastroAdicional(cadastrosAdicionais, 'CONTA_FINANCEIRA') || null,
    };
  }
  return {};
};

export const initialStateCamposErp = (tipoErp) => {
  if (tipoErp === 'TOTVS') {
    return {
      armazem: null,
      contaContabil: null,
    };
  }
  if (tipoErp === 'NEO') {
    return {
      contaContabil: null,
    };
  }
  if (tipoErp === 'SENIOR') {
    return {
      armazem: null,
    };
  }
  if (tipoErp === 'SENIOR_TEIXEIRA') {
    return {
      armazem: null,
      contaContabil: null,
      contaFinanceira: null,
    };
  }
  return {};
};
